





import { Component, Vue } from 'vue-property-decorator';
import { getLocale } from '@/i18n';
import { ConstantsModuleMapper } from '@/store/modules/constants';

const Mappers = Vue.extend({
  computed: {
    ...ConstantsModuleMapper.mapGetters(['isLoaded', 'startBetting']),
  },
});

@Component
export default class StartBetting extends Mappers {
  resolveBaseUrl(): string {
    return `${window.location.protocol}//${window.location.host}/${getLocale()}`;
  }
}
